import React from 'react';
import classNames from 'classnames';

import CheckBox from 'components/CheckBox';
import {ErrorField} from 'components/Fields';

import './styles.css';

const CheckBoxField = ({
  input: {onChange, onBlur, value, name},
  label,
  className,
  meta: {touched, error},
  onCheckBoxChange,
  disabled
}: any) => {
  const onFieldChange = event => {
    onChange(event);

    if (onCheckBoxChange) {
      onCheckBoxChange(event.target.checked);
    }
  };

  return (
    <div
      className={classNames('CheckBoxField', className, {
        error: touched && error
      })}>
      <CheckBox
        onChange={onFieldChange}
        onBlur={onBlur}
        value={value}
        label={label}
        name={name}
        disabled={disabled}
      />
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default CheckBoxField;
